import { IBaseIconProps } from "./IBaseIconProps";

/** A shield with an eye — "someone looked in, and it was recorded" (studio access log). */
export const ShieldIcon = ({ color = "#ffffff" }: IBaseIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.8 4.5 5.6v5.6c0 4.7 3.1 8.7 7.5 10 4.4-1.3 7.5-5.3 7.5-10V5.6L12 2.8z" />
      <path d="M7.8 12c1.1-1.9 2.5-2.8 4.2-2.8s3.1.9 4.2 2.8c-1.1 1.9-2.5 2.8-4.2 2.8S8.9 13.9 7.8 12z" />
      <circle cx="12" cy="12" r="1.1" />
    </svg>
  );
};
